import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  public storage: any;
  public sharedData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
}
